import { Fragment, useState } from "react";
import { Input, Select, Option } from "@material-tailwind/react";
import NextBack from "./NextBack";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  boatPriceForm,
  boatPriceSchema,
} from "../../pages/boat/createBoatValidation";
import ErrorParagraph from "../common/ErrorParagraph";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { useMutation, useQuery } from "react-query";
import { handleErrorMessage } from "../../utility";
import { BoatService } from "../../services/boatService";
import { toast } from "react-toastify";
import { PricingAvailability } from "../../models/boat/pricingAvailability";
import DefaultLoading from "../common/DefaultLoading";
import ErrorLoadingState from "../common/buttons/ErrorLoadingState";

function Pricing() {
  const noStateSelected = "Please Select State";
  const [availability, setAvailability] = useState(noStateSelected);
  const { setStepNumber, setOnBoardingPage, setTab } = useOnboardingStore();
  const { isLoading, data, error } = useQuery<PricingAvailability>(
    "Trip Rating",
    () => api.get(ApiRoutes.getTripAvailability),
    {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: (data) => {
        console.log(data);
      },
    }
  );

  const handleStateChange = (value: string | undefined) => {
    if (!value) return;
    const availability = value;
    console.log(value);
    setAvailability(value);
    setValue("tripAvailabilityOptions", availability);
  };

  const {
    register,
    handleSubmit,
    setValue,

    formState: { errors },
  } = useForm<boatPriceForm>({
    resolver: yupResolver(boatPriceSchema),
  });

  const onSubmit = (data: boatPriceForm) => {
    if (!BoatService.getCurrentBoatId) return;
    const price = { ...data, boatId: BoatService.getCurrentBoatId };
    console;
    createPricingMutation.mutate(price);
  };

  const createPricingMutation = useMutation(
    (data: boatPriceForm) => api.post(ApiRoutes.boatPrice, data),
    {
      onSuccess: (data) => {
        console.log(data);
        setStepNumber(6);
        toast.success("Pricing created successfully");
        setOnBoardingPage("Publish");
        setTab("Publish");
      },
      onError: (error) => {
        handleErrorMessage(
          error,
          "Unable to create pricing please try again later"
        );
      },
    }
  );

  if (isLoading)
    return (
      <div className="flex items-center justify-center ">
        <DefaultLoading />
      </div>
    );

  if (error) {
    return <ErrorLoadingState />;
  }

  return (
    <Fragment>
      <form
        className="flex flex-col items-center"
        onSubmit={() => handleSubmit(onSubmit)}
      >
        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Prices of hire per hour (Naira)"
            {...register("hourlyRate")}
          />
          {errors.hourlyRate && (
            <ErrorParagraph message={errors.hourlyRate.message!} />
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Select
            placeholder={undefined}
            value={availability}
            {...register("tripAvailabilityOptions")}
            onChange={(value) => handleStateChange(value)}
            label="Availability"
          >
            {data?.data.payload.data.map((item) => (
              <Option key={item.id} value={item.id.toString()}>
                {item.name}
              </Option>
            ))}
          </Select>

          {errors.tripAvailabilityOptions && (
            <ErrorParagraph message={errors.tripAvailabilityOptions.message!} />
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Penalty fee for delay (in percentage)"
            {...register("penaltyFee")}
          />
          {errors.penaltyFee && (
            <ErrorParagraph message={errors.penaltyFee.message!} />
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Seat capacity"
            {...register("seatCapacity")}
          />
          {errors.seatCapacity && (
            <ErrorParagraph message={errors.seatCapacity.message!} />
          )}
        </div>
      </form>
      <NextBack
        shouldGoNext={true}
        shouldGoBack={false}
        isLoading={createPricingMutation.isLoading}
        next={() => handleSubmit(onSubmit)()}
        back={() => {}}
      />
    </Fragment>
  );
}

export default Pricing;
